
export default class App {

    // This is used as a unique key in the localStorage
    public static id = 'EscapeRoom001A-v1';

    public static SERVER = 'https://multiplayer.javilabs.es';


    // https://developer.mozilla.org/es/docs/Web/API/API_de_almacenamiento_web/Usando_la_API_de_almacenamiento_web
    public static localStorageAvailable() {
        try {
            const storage = window.localStorage;
            let x = '__storage_test__';;
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return false;
        }
    }

}